import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from '../buttons/button';
import { AuthContext } from '../../context/AuthContext';
import { closeInactiveUserModal } from '../../reducers/uiSlice';

const InactiveUserModal = () => {
  const isOpen = useSelector(state => state.ui.inactiveUserModalOpen);
  const { logout } = useContext(AuthContext);
  const dispatch = useDispatch();

  const handleLogout = () => {
    logout();
    dispatch(closeInactiveUserModal());
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm mx-auto p-8 text-center">
        <h3 className="mb-3 font-semibold text-xl text-gray-800 uppercase">
          Account Inactive
        </h3>
        <p className="mb-8 max-w-md mx-auto text-md text-gray-600 leading-5">
          Your account is currently inactive. Please contact your administrator for assistance.
        </p>
        <Button 
          onClick={handleLogout} 
          variant="danger"
          fullWidth
        >
          Okay
        </Button>
      </div>
    </div>
  );
};

export default InactiveUserModal;